import {Injectable} from "@angular/core";
import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {InsolesSummaryCamDocumentModel} from "./insolesSummaryCamDocument.model";
import {CamMachineSummaryConverter} from "../../../../3d/cam/machine/api/model/camMachineSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesSummaryCamDocumentConverter extends HttpModelConverter<InsolesSummaryCamDocumentModel>{

    constructor(private camMachineSummaryConverter: CamMachineSummaryConverter) {
        super();
    }

    protected createInstance(): InsolesSummaryCamDocumentModel {
        return new InsolesSummaryCamDocumentModel();
    }

    protected enrichObject(result: InsolesSummaryCamDocumentModel,
                           src: InsolesSummaryCamDocumentModel) {
        result.camMachine = this.camMachineSummaryConverter.convert(src.camMachine);
    }

}